:host {
  --cms-quoteImageColor: var(--cms-semanticColors-primary-textOnBackground);
  --cms-text-color: var(--cms-semanticColors-primary-textOnBackground);
  --cms-headline-text-color: var(--cms-theme-inverted-text-color);
  --cms-top-spacing: 0;

  @include cms-default-grid-container;
  @include cms-base-font-100;
  margin-bottom: var(--cms-components-mb);
  margin-top: var(--cms-top-spacing);
}

:host([headline]) {
  --cms-top-spacing: var(--cms-spacing-300);
}

.infobox-inner {
  position: relative;
  grid-area: var(--cms-default-grid-area);
  padding: var(--cms-spacing-100);
  background-color: var(--cms-semanticColors-primary-background);
}

.infobox-headline-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  top: -2rem;
  left: 0;
}

.infobox-text-wrapper * {
  color: var(--cms-text-color);
}

.infobox-text-wrapper p:first-of-type {
  margin-top: 0;
}

.svg-warning-wrapper {
  display: flex;
  align-items: center;
}

@include media-width($breakpoint-sm) {
  .infobox-inner {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }
}